// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rAKqg","title":"styles_title__2fgQw"};